package com.xtream.ui.tv.presentation.common


import androidx.compose.animation.core.Spring
import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.animation.core.spring
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.calculateStartPadding
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.LazyListScope
import androidx.compose.foundation.lazy.LazyListState
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.lazy.grid.GridCells
import androidx.compose.foundation.lazy.grid.LazyGridState
import androidx.compose.foundation.lazy.grid.LazyVerticalGrid
import androidx.compose.foundation.lazy.grid.rememberLazyGridState
import androidx.compose.foundation.lazy.itemsIndexed
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Text
import androidx.compose.material3.TopAppBar
import androidx.compose.material3.TopAppBarDefaults
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.MutableIntState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableIntStateOf
import androidx.compose.runtime.mutableStateMapOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.focus.focusRestorer
import androidx.compose.ui.focus.onFocusChanged
import androidx.compose.ui.focus.onFocusEvent
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.LayoutDirection
import androidx.compose.ui.unit.dp
import androidx.lifecycle.compose.LifecycleResumeEffect
import androidx.paging.compose.LazyPagingItems
import androidx.paging.compose.itemContentType
import androidx.paging.compose.itemKey
import com.xtream.ui.platform.adaptiveValue
import com.xtream.ui.platform.isDpadNavigation
import com.xtream.sharedResources.resources.Res
import com.xtream.sharedResources.resources.view_all
import com.xtream.data_kmp.dto.BaseStream
import com.xtream.data_kmp.dto.CategoryBase
import com.xtream.data_kmp.dto.CategoryWithStream
import com.xtream.ui.ui.widget.FocusPositioner
import org.jetbrains.compose.resources.stringResource


@Composable
fun ContentScreen(
    title: @Composable (() -> Unit)?=null,
    actions: @Composable (RowScope.() -> Unit)?=null,
    rowItemFraction: Float = 50f,
    onCategoryClicked: ((CategoryBase?) -> Unit)? = null,
    requestFocusOnStart: Boolean = false,
    carousel: (@Composable () -> Unit)? = null,
    rowActionTitle: String? = stringResource( Res.string.view_all),
    contentPadding: PaddingValues = PaddingValues(),

    rowsContentPadding: PaddingValues? =null,
    rowHeight: Dp = 150.dp,
    listState: LazyListState = rememberLazyListState(),

    lazyPagingItems: LazyPagingItems<out CategoryWithStream<out Any, out CategoryBase>>,
    buildExtraContent:  @Composable ((item:Any?, title:String?,rowFocusRequester: FocusRequester?, focusRequester:FocusRequester? ) -> Unit)={ _, _,_,_->},
    buildRowContent:  @Composable ((item:Any?, columnFocusRequester: FocusRequester?, rowFocusRequester: FocusRequester?, focusRequester:FocusRequester?,index:Int, rowListState: LazyListState ) -> Unit)={ _, _,_,_,_,_->},


    ){




    val columnFocusRequester = remember {  FocusRequester()  }
    val firstRowFocusRequester = remember {  FocusRequester()  }
    var hasRequestedStartFocus by rememberSaveable { mutableStateOf(false) }
    LaunchedEffect(requestFocusOnStart) {
        if (requestFocusOnStart && !hasRequestedStartFocus) {
            columnFocusRequester.requestFocus()
            hasRequestedStartFocus = true
        }
    }

    val showRowActionTitle = adaptiveValue( expandedValue = false, compactValue = true, default = true)

    Scaffold(
        topBar = {
            if(title!=null || actions!=null) {
                @OptIn(ExperimentalMaterial3Api::class)

                TopAppBar(
                    colors = TopAppBarDefaults.topAppBarColors(
                        containerColor = MaterialTheme.colorScheme.background
                    ),
                    title = { title?.invoke() },
                    actions = { actions?.invoke(this) }
                )
            }
        }
    ) { innerPadding->



        LazyColumn(
            state= listState,
            contentPadding =  PaddingValues(top=innerPadding.calculateTopPadding()+contentPadding.calculateTopPadding()),
            modifier = Modifier
                .focusRequester(columnFocusRequester)
                .focusRestorer(firstRowFocusRequester)
        ) {
            if(carousel!=null)
                item("Carousel") {
                    carousel.invoke()

                }




            items(lazyPagingItems.itemCount,
                key = lazyPagingItems.itemKey{ it->it.category.categoryId?:it.hashCode()},
                contentType = {
                    lazyPagingItems.itemContentType{ it.category}
                }
            ) {it->
                val category = lazyPagingItems[it]
                val rowFocusRequester = if (it==0) firstRowFocusRequester else remember { FocusRequester() }
                val firstItemFocusRequester = remember { FocusRequester() }
                val listScrollState = rememberSaveable(saver = LazyListState.Saver) {
                    LazyListState()
                }

                FocusPositioner(
                    parentFraction = rowItemFraction,
                    childFraction = 0f,
                ) {
                    LazyContentRow(
                        state = listScrollState,
                        focusRequester =rowFocusRequester,
                        focusRestorer = firstItemFocusRequester,
                        modifier = Modifier,
                        title =category?.category?.categoryName,
                        contentPadding = rowsContentPadding?:PaddingValues(start = 16.dp, end= 48.dp),
                        actionTitle =if(showRowActionTitle) rowActionTitle else null,
                        onActionClick={ onCategoryClicked?.invoke( category?.category )}){
                        itemsIndexed (
                            category?.streams.orEmpty(),
                            key = {index, item-> (item as? BaseStream?)?.streamId?:index}
                        ){index, item->

                            buildRowContent.invoke( item,columnFocusRequester ,rowFocusRequester,if(index==0) firstItemFocusRequester else null,index, listScrollState)


                        }

                        if (!showRowActionTitle)
                            category?.size?.let {
                                if (it > 7)
                                    item {
                                        buildExtraContent(category.streams.first(), category.category.categoryName, rowFocusRequester, columnFocusRequester )
                                    }
                            }
                    }
                }
            }



        }
    }





}






@Composable
fun ContentGridScreen(
    modifier: Modifier= Modifier,
    title: @Composable (() -> Unit)?=null,
    actions: @Composable (RowScope.() -> Unit)? = null,
    carousel: (@Composable () -> Unit)? = null,
    lazyPagingItems: LazyPagingItems<out BaseStream>,
    numColumns:Int=3,
    scrollState:LazyGridState = rememberLazyGridState(),

    rowIItem:  @Composable ((BaseStream?) -> Unit)={},
){







    Scaffold(
        modifier = modifier,
        topBar = {
            @OptIn(ExperimentalMaterial3Api::class)

            if(title!=null || actions!=null)
                TopAppBar(
                    colors = TopAppBarDefaults.topAppBarColors(
                        containerColor = MaterialTheme.colorScheme.background
                    ),
                    title = { title?.invoke() },
                    actions = { actions?.invoke(this) }
                )
        },
    ) { innerPadding->

        LazyVerticalGrid (
            columns = GridCells.Fixed(numColumns), // 3 columns

            state= scrollState,
            contentPadding = PaddingValues(top=innerPadding.calculateTopPadding()+16.dp, bottom = 24.dp, start = 6.dp, end = 6.dp),
            horizontalArrangement =  Arrangement.spacedBy(6.dp),
            verticalArrangement =  Arrangement.spacedBy(10.dp),
            modifier = Modifier) {
            if(carousel!=null)
                stickyHeader {
                    carousel()
                }


            items(lazyPagingItems.itemCount,
                key = lazyPagingItems.itemKey{ it->it.streamId},
                contentType = {null
                }
            ) {
                val stream = lazyPagingItems[it]
                rowIItem.invoke( stream)



            }



        }
    }

}






class RowFocusState(
    // ✅ Passed in from outside so rememberSaveable can own it
    private val lastFocusedItemState: MutableIntState = mutableIntStateOf(0)
) {
    internal val itemFocusRequesters = mutableStateMapOf<Int, FocusRequester>()

    var lastFocusedItem: Int
        get() = lastFocusedItemState.intValue
        internal set(value) { lastFocusedItemState.intValue = value }

    val currentRestorer: FocusRequester
        get() = itemFocusRequesters[lastFocusedItem] ?: FocusRequester.Default

    fun itemModifier(index: Int, onFocusChange: ((isFocused:Boolean) -> Unit)? = null): Modifier = Modifier
        .focusRequester(itemFocusRequesters.getOrPut(index) { FocusRequester() })
        .onFocusChanged { if (it.isFocused) lastFocusedItem = index
            onFocusChange?.invoke( it.isFocused)
        }
}

@Composable
fun rememberRowFocusState(): RowFocusState {
    // ✅ rememberSaveable for the index — survives lazy disposal & process death
    val lastFocusedItemState = rememberSaveable { mutableIntStateOf(0) }
    // ✅ remember (not saveable) for the class — FocusRequester instances
    //    are always recreated anyway; only the index needs to persist
    return remember { RowFocusState(lastFocusedItemState) }
}

// ─── Library ───────────────────────────────────────────────────────────────
@Composable
fun LazyContentRow(
    modifier: Modifier = Modifier,
    focusRequester: FocusRequester = FocusRequester.Default,
    focusRestorer: FocusRequester = FocusRequester.Default, // plain, not lambda
    contentPadding: PaddingValues = PaddingValues(horizontal = 16.dp),
    title: String? = null,
    actionTitle: String? = null,
    onActionClick: (() -> Unit)? = null,
    state: LazyListState = rememberLazyListState(),
    content: LazyListScope.() -> Unit
) {
    var hasFocus by rememberSaveable { mutableStateOf(false) }
    val useAlpha =   isDpadNavigation()//adaptiveValue(expandedValue = true, compactValue = false, default = false)
    val animatedAlpha by animateFloatAsState(
        targetValue = if (hasFocus || !useAlpha) 1f else 0.3f,
        animationSpec = spring(
            dampingRatio = Spring.DampingRatioMediumBouncy, // bounciness
            stiffness = Spring.StiffnessMedium              // speed
        ),
        label = "focus_alpha"
    )

    Column(


        modifier = Modifier.graphicsLayer {
            alpha = animatedAlpha
        }
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = contentPadding.calculateStartPadding(LayoutDirection.Ltr))
                .padding(bottom = 12.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Text(text = title ?: "", style = MaterialTheme.typography.titleMedium, modifier = Modifier.weight(1f))
            if (actionTitle != null) {
                Text(
                    text = actionTitle,
                    style = MaterialTheme.typography.titleSmall,
                    color = MaterialTheme.colorScheme.primary,
                    modifier = Modifier.clickable { onActionClick?.invoke() }.clip(MaterialTheme.shapes.small)
                )
            }
        }

        LazyRow(
            state = state,
            contentPadding = contentPadding,
            horizontalArrangement = Arrangement.spacedBy(14.dp),
            modifier = modifier
                .padding(bottom = 16.dp)
                .fillMaxWidth()
                .onFocusEvent { hasFocus = it.hasFocus }
                .focusRequester(focusRequester)
                .focusRestorer(focusRestorer),
            content = content
        )
    }

    // ✅ Fires on recomposition entry after lazy disposal
    //    restoreFocusedChild() fails (node gone) → requestFocus() triggers
    //    focusRestorer which targets the correct item via the resolved requester
    LaunchedEffect(Unit) {
        if (hasFocus) {
            //   val restored =
            focusRequester.restoreFocusedChild()
            // if (!restored) focusRequester.requestFocus()
        }
    }

    // Handles Activity/Fragment resume only
    LifecycleResumeEffect(Unit) {
        //if (hasFocus) focusRequester.restoreFocusedChild()
        onPauseOrDispose {
            if (hasFocus) focusRequester.saveFocusedChild()
        }
    }
}





